export default "__VITE_ASSET__dSGSqH1H__"